import React, { useEffect, useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { salesforceClientSecret } = formData;
  const [SalesforceValidationStatus, setSalesforceValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      salesforce_client_id: ((_a = formData == null ? void 0 : formData.salesforceClientId) == null ? void 0 : _a.value) || "",
      salesforce_client_secret: ((_b = formData == null ? void 0 : formData.salesforceClientSecret) == null ? void 0 : _b.value) || "",
      salesforce_base_url: ((_c = formData == null ? void 0 : formData.salesforceBaseUrl) == null ? void 0 : _c.value) || ""
    },
    urlWithEventHubParams
  );
  useEffect(() => {
    setSalesforceValidation(null);
    if (SalesforceValidationStatus.error) {
      setFormError({
        full_message: SalesforceValidationStatus.error,
        nice_message: "Unable to connect to Salesforce using provided configuration."
      });
    }
    return () => {
      setFormError(null);
    };
  }, [SalesforceValidationStatus.error, setSalesforceValidation]);
  const handleSubmit = () => {
    setSalesforceValidation(ApiRoutes.INTEGRATIONS.Salesforce.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["salesforceName", "salesforceClientId", "salesforceClientSecret", "salesforceBaseUrl"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading: SalesforceValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceName",
        type: "text",
        fieldData: formData.salesforceName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: salesforceClientSecret == null ? void 0 : salesforceClientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceBaseUrl",
        type: "text",
        fieldData: formData.salesforceBaseUrl,
        onChange,
        label: "Base Salesforce URL",
        help: "The full base Salesforce URL for your instance. e.g. https://instance.my.salesforce.com",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceClientId",
        type: "text",
        fieldData: formData.salesforceClientId,
        onChange,
        label: "Consumer Key",
        help: "The Consumer Key of Salesforce Connected App created with sufficient API permissions.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "salesforceClientSecret",
        type: "password",
        onChange,
        fieldData: formData.salesforceClientSecret,
        help: "The Consumer Secret of the Salesforce Connected App.",
        label: "Consumer Secret",
        required: true
      }
    )
  );
};
export default StepAuthorize;
